import styled from "styled-components";

export const Heading = styled.h1`
  font-weight: var(--global-font-weight-regular);
  font-size: var(--global-font-size-l);
  margin-top: 0;
  display: flex;
`;

export const HeadingSubtext = styled.span`
  color: #707070;
  font-size: var(--global-font-size-s);
  align-self: flex-end;
  margin-left: var(--global-spacing-s);
`;
